import React, { Fragment } from "react";

import "./CardNavbar.css";

const CardNavbar = (props) => (
  <Fragment>
    <div ref={props.ref} className="mn-grid__row mn-grid__row--lg-top">
      <div className="mn-grid__col mn-grid__col--lg-12 mn-grid__col--xs-gap" >
        {props.children}                        
      </div>
    </div>
  </Fragment>
); 

export default CardNavbar;